import { ActionStatus } from '../../../common/constants/action-status';
import { StoreState } from '../../../store/store.interface';

export const isLoadingWishLists = (state: StoreState) =>
  state.wishListState.myAccountWishLists.status === ActionStatus.loading;
export const getWishListsStatus = (state: StoreState) => state.wishListState.myAccountWishLists.status;
export const getWishListsData = (state: StoreState) => state.wishListState.myAccountWishLists.data;
export const getCreateWishListStatus = (state: StoreState) => state.wishListState.createWishList.status;
export const getCreateWishListData = (state: StoreState) => state.wishListState.createWishList.data;
export const getCurrentWishList = (state: StoreState) => state.wishListState.currentWishList;
export const getDeleteWishListStatus = (state: StoreState) => state.wishListState.deleteWishList.status;
export const getEditWishListStatus = (state: StoreState) => state.wishListState.editWishList.status;
export const getEditWishListData = (state: StoreState) => state.wishListState.editWishList.data;
export const isLoadingWishList = (state: StoreState) =>
  state.wishListState.getWishListById.status === ActionStatus.loading;
export const getWishListStatus = (state: StoreState) => state.wishListState.getWishListById.status;
export const getWishListData = (state: StoreState) => state.wishListState.getWishListById.data;
export const getAddProductToWishListStatus = (state: StoreState) => state.wishListState.addProductToWishList.status;
export const getRemoveProductFromWishListStatus = (state: StoreState) =>
  state.wishListState.removeProductFromWishList.status;
export const getUpdateProductOnWishListComment = (state: StoreState) =>
  state.wishListState.updateProductOnWishListComment;
export const getWishListBySharingCodeStatus = (state: StoreState) =>
  state.wishListState.getWishListBySharingCode.status;
export const getWishListBySharingCodeData = (state: StoreState) => state.wishListState.getWishListBySharingCode.data;
export const getWishListBySharingCodeError = (state: StoreState) => state.wishListState.getWishListBySharingCode.error;
